import { FC, MouseEvent } from 'react';

import { saveAs } from 'file-saver';

import { useQRCode } from '@entities/qr';

interface IProps {
  order_hash: string;
}

export const QRCodeLink: FC<IProps> = ({ order_hash }) => {
  const { isLoading, getQRCode } = useQRCode(order_hash);

  const handleClick = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    try {
      const response = await getQRCode({ order_hash }).unwrap();
      saveAs(response.qr_link, `${order_hash}.png`);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <button onClick={handleClick} disabled={isLoading}>
      Download
    </button>
  );
};
